export default __webpack_public_path__ + "static/media/emailLogo.f6014ec3.svg";